import { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation, Link } from "react-router-dom";
import { endPoints, siteConfig } from "../../../config/end-points";
import useHttp from "../../../hooks/use-http";
import { alertAction } from "../../../store/alert-store";
import Input from "../../UI/Input";
import "../auth.css";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }
  let query = useQuery();

  useEffect(() => {
    document.title = `${endPoints.title} | Reset Password`;
  });

  const [ispassword, setIsPassword] = useState(null);
  const [emailLabel, setEmailLabel] = useState(null);
  const [confirmPassLabel, setConfirmPassLabel] = useState(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    error,
    setError,
    status: httpStatusCode,
    sendRequest: resetPasswordRequest,
  } = useHttp();

  var strongRegex = new RegExp(
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/
  );

  const passwordChangeHandler = (event) => {
    setPassword(event.target.value.trim());
    if (strongRegex.test(event.target.value.trim())) {
      setEmailLabel("Valid");
      setIsPassword(true);
    } else {
      setEmailLabel("Invalid");
      setIsPassword(false);
    }
  };

  const confirmPasswordHandler = (event) => {
    if (password === event.target.value) {
      setIsPassword(true);
      setConfirmPassLabel("Matching");
      setConfirmPassword(event.target.value);
    } else {
      setIsPassword(false);
      setConfirmPassLabel("Not Matching");
    }
  };

  const resetFormHandle = (event) => {
    event.preventDefault();

    if (ispassword) {
      resetPasswordRequest(
        {
          url: endPoints.reset_password,
          method: "POST",
          headers: {
            "access-control-allow-origin": "*",
            "Content-Type": "application/json",
          },
          body: {
            password,
            confirm_password: confirmPassword,
            token: query.get("token"),
            id: query.get("id"),
          },
        },
        responseData
      );
    }
  };

  const responseData = (response) => {
    let icon = "fa-check";
    dispatch(
      alertAction.showAlert({
        action: "show",
        alert_txt: response.message,
        alert_class: "success",
        alert_icon: icon,
      })
    );
    history.push("/login");
  };

  useEffect(() => {
    if (error && httpStatusCode) {
      let icon = "fa-user-slash";
      dispatch(
        alertAction.showAlert({
          action: "show",
          alert_txt: error,
          alert_class: "danger",
          alert_icon: icon,
        })
      );
      setError(null);
    }
  });

  return (
    <div className="auth-redesigned">
      <div className="auth-page">
        {/* Left Panel — Same as login page */}
        <div className="auth-left">
          <div className="auth-left-content">
            <h1>
              Set Your New<br />
              <span>Password.</span>
            </h1>
            <p>
              Choose a strong password to keep your account secure.
            </p>
            <div className="auth-illustration">
              <svg viewBox="0 0 400 300" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "90%", height: "auto" }}>
                {/* Shield / Lock visual */}
                <rect x="120" y="40" width="160" height="200" rx="80" fill="#F5F3FF" stroke="#EDE9FE" strokeWidth="2"/>
                {/* Lock body */}
                <rect x="160" y="130" width="80" height="70" rx="12" fill="#7C3AED"/>
                {/* Lock shackle */}
                <path d="M175 130 V105 C175 85 225 85 225 105 V130" stroke="#7C3AED" strokeWidth="12" fill="none" strokeLinecap="round"/>
                {/* Keyhole */}
                <circle cx="200" cy="158" r="10" fill="#FFFFFF"/>
                <rect x="197" y="163" width="6" height="16" rx="3" fill="#FFFFFF"/>
                {/* Checkmark badge */}
                <circle cx="260" cy="100" r="24" fill="#10B981"/>
                <path d="M248 100 L256 108 L272 92" stroke="#FFFFFF" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                {/* Floating elements */}
                <rect x="80" y="80" width="20" height="20" rx="6" fill="#7C3AED" opacity="0.15" transform="rotate(-12 90 90)"/>
                <rect x="310" y="160" width="18" height="18" rx="5" fill="#8B5CF6" opacity="0.12" transform="rotate(15 319 169)"/>
                <circle cx="320" cy="70" r="8" fill="#EDE9FE" opacity="0.6"/>
                <circle cx="90" cy="200" r="6" fill="#DDD6FE" opacity="0.5"/>
              </svg>
            </div>
          </div>
        </div>

        {/* Right Panel — Form */}
        <div className="auth-right">
          <div className="auth-form-wrapper">
            <div className="auth-form-logo">
              <img
                src={endPoints.logo}
                alt={endPoints.title}
              />
            </div>

            <h2>Reset Password</h2>
            <p className="auth-subtitle">
              Choose a strong password to secure your account.
            </p>

            <form onSubmit={resetFormHandle}>
              <div className="auth-field">
                <label>New Password</label>
                <Input
                  type="password"
                  onChange={passwordChangeHandler}
                  placeholder="Enter new password"
                />
                {emailLabel && (
                  <small className={`auth-validation-label ${emailLabel}`}>
                    {emailLabel}
                  </small>
                )}
              </div>

              <div className="auth-field">
                <label>Confirm Password</label>
                <Input
                  type="password"
                  onChange={confirmPasswordHandler}
                  placeholder="Re-enter your password"
                />
                {confirmPassLabel && (
                  <small className={`auth-validation-label ${confirmPassLabel === "Matching" ? "Valid" : "Invalid"}`}>
                    {confirmPassLabel}
                  </small>
                )}
              </div>

              <button type="submit" className="auth-submit-btn">
                Reset Password
              </button>
            </form>

            <div className="auth-footer">
              <p>{siteConfig.copyright}</p>
              <Link to="/login">Back to Sign In</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
